const UPGRADE_REQUEST_LINK = "https://www.foodsteps.earth/upgrade";

export function openUpgradeRequestLink() {
  window.open(UPGRADE_REQUEST_LINK, "_blank");
}
